<script setup lang="ts">
import { computed, onMounted, ref } from "vue";
import type { IntegrationStatus, SystemCode } from "@wjbk/workbench-contracts";
import { api } from "../api";

const rows = ref<IntegrationStatus[]>([]);
const error = ref("");
const known: Record<SystemCode, { mark: string; description: string; displayName?: string; logo?: string; href?: string }> = {
  workbench: { mark: "", logo: "/brand/workbench-logo-rounded-v2.png", description: "统一身份、权限、产品与审批归口" },
  crmeb: { mark: "商", description: "商城商品、订单与退款数据源", href: "/apps/store" },
  erpnext: { mark: "ERP", description: "生产、库存与批次成本数据源" },
  bytedesk: { mark: "客", displayName: "客服系统", description: "人工在线客服与会话工作台", href: "/apps/customer-service" },
  xht: { mark: "禾", description: "小禾堂自动客服系统", href: "https://xht.wanjubaike.cn" }
};

const cards = computed(() => rows.value.map(row => ({ ...row, ...known[row.systemCode] })));

onMounted(async () => {
  try { rows.value = await api.integrations(); }
  catch (e) { error.value = (e as Error).message; }
});
</script>

<template>
  <div class="notice honest-notice">应用入口与身份接入分开管理：显示“可打开”不代表已经完成统一登录，具体状态以卡片标识为准。</div>
  <div v-if="error" class="error">{{ error }}</div>
  <div v-else class="integration-cards">
    <article v-for="card in cards" :key="card.systemCode" class="integration-card">
      <div class="integration-card-head">
        <img v-if="card.logo" class="integration-logo" :src="card.logo" alt="玩具百科 我的玩具库" />
        <span v-else class="integration-mark">{{ card.mark }}</span>
        <div><h2>{{ card.displayName }}</h2><p>{{ card.description }}</p></div>
        <span class="integration-state" :class="{ enabled: card.enabled }">{{ card.enabled ? '已登记' : '维护中' }}</span>
      </div>
      <dl>
        <div><dt>接入方式</dt><dd>{{ card.mode === 'adapter' ? '适配器' : '仅有入口' }}</dd></div>
        <div><dt>职员身份</dt><dd>{{ card.systemCode === 'workbench' ? '统一身份源' : card.systemCode === 'crmeb' ? '一次性票据统一登录' : '映射待联调' }}</dd></div>
        <div><dt>最近同步</dt><dd>{{ card.lastSuccessAt || '暂无记录' }}</dd></div>
      </dl>
      <div v-if="card.lastError" class="integration-error">{{ card.lastError }}</div>
      <RouterLink v-if="card.href?.startsWith('/')" :to="card.href" class="integration-entry">{{ card.systemCode === 'crmeb' ? '进入小程序商城' : '打开系统' }} <span>→</span></RouterLink>
      <a v-else-if="card.href" :href="card.href" target="_blank" rel="noopener" class="integration-entry">打开系统 <span>↗</span></a>
      <button v-else type="button" class="integration-entry disabled" disabled>入口待配置</button>
    </article>
  </div>
</template>
